import React, { useEffect, useState } from 'react';
import axios from 'Uitilities/axios';
import { useSearchParams } from 'react-router-dom';
import Table from 'Components/Table';

const AnalyzeListResult = ({ searchCondition,bridgeData,setbridgeData,setselectedBridge }) => {
  const [searchParams] = useSearchParams();
  const getApiEndpoint = () => {
    const testType = searchParams.get('testType') || 'A'; // 預設為 A
    if (testType === 'B') {
      return 'https://tybms.tycg.gov.tw/newApi/BridgeTest/TestProritySearchNextYear';
    } else if (testType === 'C') {
      return 'https://tybms.tycg.gov.tw/newApi/BridgeTest/GetBridgeTestRHM';
    } else {
      return 'https://tybms.tycg.gov.tw/newApi/BridgeTest/TestProritySearchThisYear';
    }
  };
  const columns = [
    {
      dataField: "bridgeName",
      text: "橋梁名稱",
    },
    {
      dataField: "build_year",
      text: "竣工年分",
      sort: true,
      formatter: (cell) => {
        // 若 build_year 的值小於 0，顯示 "無相關資料"
        return cell < 0 ? "無相關資料" : cell;
      }
    },
    {
      dataField: "u",
      text: "U值",
      sort: true,
    },
    {
      dataField: "corrosion_fe",
      text: "腐蝕等級(碳鋼)",
      sort: true,
    },
    {
      dataField: "girder_material",
      text: "主梁材質",
      sort: true,
    },
    {
      dataField: "town",
      text: "所在區鄉",
      sort: true,
    },
    {
      dataField: "bridgeType",
      text: "橋梁類型",
      sort: true,
      formatter: (cell) => {
        // 根據 cell 的值返回相應的中文名稱
        return cell === "carbridge" ? "車行橋" : cell === "footbridge" ? "人行橋" : cell;
      }
    }
  ];
  const Download = async () => {
    try {
      const response = await axios({
        method: 'post',
        url: 'https://tybms.tycg.gov.tw/newApi/BridgeTest/ExportAnalyzeResultExcel',
        data: bridgeData,
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', '篩選結果.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('匯出失敗:', error);
      alert('匯出失敗，請稍後再試');
    }
  };

  async function getBridgeInformation() {
    if (searchCondition && searchCondition.length > 0) {
      console.log("searchCondition:", searchCondition);
      const apiEndpoint = getApiEndpoint(); // 根據 testType 獲取 API 端點
      await axios.post(apiEndpoint, searchCondition)
        .then(res => {
          console.log("API response:", res.data);
          // 只保留 use_Status 為 "正常使用" 的資料
          const filteredData = res.data.filter(item => item.use_Status === "正常使用");
          setbridgeData(filteredData);
        })
        .catch(err => alert(err));
    }
  }
 // const rowEvents = {
  //  onClick: (e, row, rowIndex) => {
  //    console.log("selected bridge:", row);
  //    setselectedBridge(row)
 //   }
 // }
  useEffect(() => {
    if (searchCondition.length > 0) {
      getBridgeInformation();
    }
  }, [searchCondition]);
  useEffect(() => {
    console.log("searchCondition updated:", searchCondition);
    getBridgeInformation() }, [searchCondition])
  useEffect(() => {
      console.log("bridgeData updated:", bridgeData); // 查看 bridgeData 變化
    }, [bridgeData])
  useEffect(() => {
    console.log("TestPrioritySearch 已渲染");
}, []);
  return (
    <>
      <div className="searchResult">
        <div className="text-left d-flex">
          <h5>篩選結果</h5>
        </div>

      </div>
      <Table data={bridgeData} columns={columns} fileName="篩選結果.xlsx"  download={Download} keyField={"id"} />

    </>
  )
}

export default AnalyzeListResult;